import { campaignConfig } from "./campaign-config";
import { nonEmptyString } from "./app/media";
import { safeHttpUrl } from "./app/safe-url";
import { initWinnerRevealAnimations } from "./features/reveal-on-view";

const MOBILE_INITIAL_RESULTS = 8;

function winnerLabel({ number, series }, referencePlaceholder = false) {
  if (referencePlaceholder) return "Núm: XXXXX | Serie: XX";
  return `Núm: ${number} | Serie: ${series}`;
}

function grandPrizeLabel({ number, series }, referencePlaceholder = false) {
  const numberLabel = document.createElement("span");
  numberLabel.textContent = `Núm: ${referencePlaceholder ? "XXXXX" : number}`;
  const separator = document.createElement("span");
  separator.className = "winner-results__grand-prize-separator";
  separator.textContent = " | ";
  const seriesLabel = document.createElement("span");
  seriesLabel.textContent = `Serie: ${referencePlaceholder ? "XX" : series}`;
  return [numberLabel, separator, seriesLabel];
}

export function initWinners(config = campaignConfig) {
  const section = document.querySelector("[data-winner-results]");
  const data = config.winners;

  if (!section || !data?.grandPrize || !data?.secondaryPrizes?.length) return;

  const grandPrize = section.querySelector("[data-grand-prize]");
  const demoNotice = section.querySelector("[data-winner-demo-note]");
  const introCopy = section.querySelector("[data-winner-intro]");
  const secondaryTitle = section.querySelector("[data-secondary-title]");
  const secondaryCopy = section.querySelector("[data-secondary-copy]");
  const list = section.querySelector("[data-secondary-winners]");
  const loadMore = section.querySelector("[data-load-more]");
  const status = section.querySelector("[data-winner-status]");
  const referencePlaceholder = data.referencePlaceholder === true;
  const initialVisibleResults = window.matchMedia("(width < 1024px)").matches
    ? MOBILE_INITIAL_RESULTS
    : data.secondaryPrizes.length;
  let visibleResults = initialVisibleResults;

  const grandPrizeNumber = document.createElement("p");
  grandPrizeNumber.replaceChildren(...grandPrizeLabel(data.grandPrize, referencePlaceholder));
  const grandPrizeTitle = document.createElement("h3");
  grandPrizeTitle.textContent = nonEmptyString(data.grandPrizeTitle)
    ? data.grandPrizeTitle
    : "Primer Premio: 100.000€";
  grandPrize.replaceChildren(grandPrizeNumber, grandPrizeTitle);

  if (demoNotice && nonEmptyString(data.demoNotice)) {
    demoNotice.textContent = data.demoNotice;
    demoNotice.hidden = false;
  }

  if (introCopy && nonEmptyString(data.introCopy)) {
    introCopy.textContent = data.introCopy;
  }

  if (secondaryTitle && nonEmptyString(data.secondaryTitle)) {
    secondaryTitle.textContent = data.secondaryTitle;
  }

  secondaryCopy.textContent = nonEmptyString(data.secondaryCopy)
    ? data.secondaryCopy
    : "Comprueba si la combinación de tu envoltorio (Número y Serie) se encuentra en la siguiente lista o descárgate el listado oficial (PDF).";

  const officialPdfUrl = safeHttpUrl(data.officialPdfUrl, { allowAnyHttps: true });
  if (officialPdfUrl) {
    secondaryCopy.textContent = "Comprueba si la combinación de tu envoltorio (Número y Serie) se encuentra en la siguiente lista o ";
    const officialPdf = document.createElement("a");
    officialPdf.href = officialPdfUrl;
    officialPdf.target = "_blank";
    officialPdf.rel = "noopener noreferrer";
    officialPdf.textContent = "descárgate el listado oficial (PDF).";
    secondaryCopy.append(officialPdf);
  } else if (!secondaryCopy.textContent.trim().endsWith(".")) {
    secondaryCopy.append(".");
  }

  list.replaceChildren();
  const items = data.secondaryPrizes.map((winner) => {
    const item = document.createElement("li");
    item.textContent = winnerLabel(winner, referencePlaceholder);
    list.append(item);
    return item;
  });

  const updateResults = () => {
    items.forEach((item) => {
      item.hidden = true;
    });
    items.forEach((item, index) => {
      item.hidden = index >= visibleResults;
    });

    const shown = Math.min(visibleResults, items.length);
    loadMore.hidden = shown >= items.length;
    status.textContent = `${shown} de ${items.length} números mostrados.`;
  };

  loadMore.addEventListener("click", () => {
    visibleResults += MOBILE_INITIAL_RESULTS;
    updateResults();
  });

  section.hidden = false;
  updateResults();
  initWinnerRevealAnimations();
}
